"use strict";

const MeticulousPort = {
  add: function (app) {
    app.ports.meticulousRecordContext.subscribe(function (context) {
      const ctx = window.Meticulous?.context;
      if (!ctx) return;

      if (context.userId) ctx.recordUserId?.(context.userId);
      if (context.practiceId) ctx.recordCustomContext?.("practiceId", context.practiceId);
      if (context.scope) ctx.recordCustomContext?.("scope", context.scope);
    });
  },
};

module.exports = MeticulousPort;
